/**
 * Форматує ціну: мінімум 2 знаки після коми, максимум `maxFractionDigits`, з групуванням розрядів.
 * Реєструється як `Vue.prototype.$formatPrice` (main.js).
 * @param {number} value
 * @param {number} [maxFractionDigits=2]
 * @param {string} [locale='uk']
 * @returns {string}
 */
export function formatPrice(value, maxFractionDigits = 2, locale = 'uk') {
  return new Intl.NumberFormat(locale, {
    style: 'decimal',
    minimumFractionDigits: 2,
    maximumFractionDigits: maxFractionDigits,
    useGrouping: true
  }).format(value)
}

/**
 * Форматує грошове значення ставки за правилом сторінки тендера:
 * право `detailedReducePrice` -> `$n(value, 'decimal_5')`; інакше `tenderSettings.priceRoundingDigit` >= 2
 * -> `$formatPrice(value, digits)`; інакше `$n(value, 'decimal')`.
 * Реєструється як `Vue.prototype.$formatBidPrice` (main.js) — `this` є екземпляром компонента.
 * @param {number} value
 * @returns {string}
 */
export function formatBidPrice(value) {
  if (this.$can('is', 'detailedReducePrice')) {
    return this.$n(value, 'decimal_5')
  }
  // Number(): налаштування приходить рядком; < 2 дало б RangeError в Intl (max < min) — тоді стандартний формат
  const digits = Number(this.$store.getters.getTendersSettings?.priceRoundingDigit)
  if (digits >= 2) {
    return formatPrice(value, digits)
  }
  return this.$n(value, 'decimal')
}
